import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { styled } from '@mui/material/styles'
import LeftArrow from '@/assets/Left 1.svg'
import './TopNav.css'

const CustomAppBar = styled(AppBar)({
  backgroundColor: 'transparent',
  height: '10vh',
})

const TopNav = ({ showArrow }: { showArrow?: boolean }) => {
  const navigate = useNavigate()
  return (
    <CustomAppBar position="static">
      <Toolbar>
        {showArrow && (
          <img
            src={LeftArrow}
            alt="Left arrow"
            onClick={() => navigate(-1)}
            className="arrow text-red-600 cursor-pointer"
          />
        )}
      </Toolbar>
    </CustomAppBar>
  )
}

export default TopNav
